table.quick-sets
  thead
    tr
      td Set
      each team in match.teams
        th= team.name
  tbody
    for set, i in quickSets
      - let isLast = i === quickSets.length - 1
      tr
        td
          ft-button.add(disabled)= 'Set ' + (i + 1)
        td
          input(
            type='number',
            value=set[0],
            (input)=set[0] = e.target.value)
        td
          input(
            type='number',
            value=set[1],
            (input)=set[1] = e.target.value)
      if i === quickSets.length - 1 && i < 4
        tr
          td
            ft-button.add(
              success,
              (click)=this.addQuickSet()
            ) Add Set
.submit((click)=this.submit())
  ft-button(success) Submit Quick Sets
